// extracted by mini-css-extract-plugin
export default {"iconArrowLeft":"ila5wZTbfBY7W2i4MDn7","iconArrowRight":"hJKObzeMTMmmA9Set9_Z","iconChevronDown":"FRGXf3RdLQxuIOgNxI1o"};